export class ApiRequestError extends Error {
  readonly status: number;
  /** Stable machine-readable reason from the backend, when it sends one (e.g. AGE_RESTRICTED). */
  readonly code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = 'ApiRequestError';
    this.status = status;
    this.code = code;
  }
}

export function isApiRequestError(error: unknown): error is ApiRequestError {
  return error instanceof ApiRequestError;
}
